import {getTrustAccountMenuActions, TrustAccountMoreMenu} from './TrustAccountMoreMenu';

import type {MemberTrustAccountListHandlers, MemberTrustAccountListItem} from '../utils';
import type {FC} from 'react';

export interface TrustAccountListItemMenuProps extends Pick<
  MemberTrustAccountListHandlers,
  'onEditAccount' | 'onDeleteAccount'
> {
  item: MemberTrustAccountListItem;
}

/** A member list row's or card's menu: copy the number, plus whatever the status and the caller's rights allow. */
export const TrustAccountListItemMenu: FC<TrustAccountListItemMenuProps> = ({
  item,
  onEditAccount,
  onDeleteAccount
}) => {
  const {canManage, canDelete} = item.permissions;

  return (
    <TrustAccountMoreMenu
      refId={item.refId}
      actions={getTrustAccountMenuActions(item.trustStatus)}
      orientation="vertical"
      onEdit={canManage && onEditAccount ? () => onEditAccount(item) : undefined}
      onDelete={canDelete && onDeleteAccount ? () => onDeleteAccount(item) : undefined}
    />
  );
};
